import request from '@/utils/request';

const PATH = '/stay/room';

export const getStayRoomList = (params: any) => request({
  url: PATH,
  method: 'get',
  params: {
    ...params,
    page: params.page - 1,
  },
});

export const getStayRoomListAll = () => request({
  url: `${PATH}/all`,
  method: 'get',
});

export const getStayRoom = (idx: any) => request({
  url: `${PATH}/${idx}`,
  method: 'get',
});

export const addStayRoom = (data: any) => request({
  url: PATH,
  method: 'post',
  data,
});

export const reserveStayRoom = (data: any) => request({
  url: `${PATH}/reserve`,
  method: 'post',
  data,
});

export const updateStayRoom = (idx: any, data: any) => request({
  url: `${PATH}/${idx}`,
  method: 'put',
  data,
});

export const deleteStayRoom = (idx: any) => request({
  url: `${PATH}/${idx}`,
  method: 'delete',
});

export const copyStayRoom = (idx: any) => request({
  url: `${PATH}/${idx}/copy`,
  method: 'post',
});

/* eslint-disable */
export const defaultStayRoom = () => {
  return {
    name: '',
    introduction: '',
    standardPeople: 2,
    maxPeople: 4,
    price: 0,
    useStatus: true,
    usageInstruction: '',
    bedType: '',
    images: [],
    smokingStatus: false,
    options: [],
    optionTypes: [],
    singleBedNum: 0,
    doubleBedNum: 0,
    twinBedNum: 0,
    queenBedNum: 0,
    kingBedNum: 0,
    beddingNum: 0,
    toiletNum: 0,
    roomPrice: {
      mondayPrice: 0,
      mondayUsable: true,
      mondayQuantity: 0,
      tuesdayPrice: 0,
      tuesdayUsable: true,
      tuesdayQuantity: 0,
      wednesdayPrice: 0,
      wednesdayUsable: true,
      wednesdayQuantity: 0,
      thursdayPrice: 0,
      thursdayUsable: true,
      thursdayQuantity: 0,
      fridayPrice: 0,
      fridayUsable: true,
      fridayQuantity: 0,
      saturdayPrice: 0,
      saturdayUsable: true,
      saturdayQuantity: 0,
      sundayPrice: 0,
      sundayUsable: true,
      sundayQuantity: 0,
      holidayPrice: 0,
      holidayUsable: true,
      holidayQuantity: 0,
      holidayBeforePrice: 0,
      holidayBeforeUsable: true,
      holidayBeforeQuantity: 0,
    },
    pricePartList: [],
  };
};
